import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import PodBanner from '../../components/PodBanner';
import AvgNetPrice from './AvgNetPrice';
import AnnualTuition from './AnnualTuition';
import ReceivingAid from './ReceivingAid';
import NeedMet from './NeedMet';
import RoomAndBoard from './RoomAndBoard';
import TuitionAndFees from './TuitionAndFees';
import FinancialAidSection from './FinancialAidSection';
import AvgNetCostSection from './AvgNetCostSection';
import TransferScholarshipsAvailable from '../OverviewMenu/TransferScholarshipsAvailable';
import withHostContext from '../../context/host/consumer';

const CostsMenu = ({
  applicationStatistics,
  costs,
  tuitionStatistics,
  transferAdmissions,
  collegeState,
  hostContext,
  scholarships,
  userData,
  testScores,
  highSchool,
  featureFlags,
  permissions,
  session,
  scid,
}) => {
  const isCamino = get(hostContext, 'isCamino', false);
  const releaseSharedScholarships = get(featureFlags, 'releaseSharedScholarships', false);

  return (
    <React.Fragment>
      <PodBanner>
        <AnnualTuition
          tuition={get(costs, 'tuition', {})}
          lastUpdated={get(costs, 'lastUpdated.value', '')}
        />
        <RoomAndBoard
          roomAndBoard={get(costs, 'roomAndBoardCharge.value', '')}
          lastUpdated={get(costs, 'lastUpdated.value', '')}
        />
        <AvgNetPrice
          isCamino={isCamino}
          averageNetPrices={get(costs, 'averageNetPrices', {})}
          lastUpdated={get(costs, 'lastUpdated.value', '')}
        />
        {isCamino ? (
          <React.Fragment>
            <TransferScholarshipsAvailable transferAdmissions={transferAdmissions} />
            <NeedMet
              meetsFullFinancialNeeds={get(costs, 'meetsFullFinancialNeeds.value', false)}
            />
            <ReceivingAid
              receivingAid={get(costs, 'receivingAid', {})}
              lastUpdated={get(costs, 'lastUpdated.value', '')}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <ReceivingAid
              receivingAid={get(costs, 'receivingAid', {})}
              lastUpdated={get(costs, 'lastUpdated.value', '')}
            />
            <NeedMet
              meetsFullFinancialNeeds={get(costs, 'meetsFullFinancialNeeds.value', false)}
            />
          </React.Fragment>
        )}
      </PodBanner>
      {releaseSharedScholarships && (
        <FinancialAidSection
          applicationStatistics={applicationStatistics}
          costsData={costs}
          scholarships={scholarships}
          userData={userData}
          testScores={testScores}
          highSchool={highSchool}
          tuitionStatistics={tuitionStatistics}
          featureFlags={featureFlags}
          permissions={permissions}
          session={session}
          scid={scid}
        />
      )}
      <AvgNetCostSection averageNetPrices={get(costs, 'averageNetPrices', {})} />
      <TuitionAndFees
        costsData={costs}
        tuitionStatistics={tuitionStatistics}
        collegeState={collegeState}
      ></TuitionAndFees>
      {!releaseSharedScholarships && (
        <FinancialAidSection
          costsData={costs}
          tuitionStatistics={tuitionStatistics}
          featureFlags={featureFlags}
        />
      )}
    </React.Fragment>
  );
};

CostsMenu.propTypes = {
  applicationStatistics: PropTypes.object,
  costs: PropTypes.object,
  tuitionStatistics: PropTypes.object,
  transferAdmissions: PropTypes.object,
  collegeState: PropTypes.string,
  scholarships: PropTypes.object,
  userData: PropTypes.object,
  testScores: PropTypes.arrayOf(PropTypes.object),
  highSchool: PropTypes.object,
  featureFlags: PropTypes.object,
  permissions: PropTypes.object,
  session: PropTypes.object,
  scid: PropTypes.number,
};

export default withHostContext(CostsMenu);
